import { createApp } from 'vue'
import Vuex from 'vuex'
const app = createApp({})

app.use(Vuex)

let customerIsOperationPossible = sessionStorage.getItem('customerIsOperationPossible')
if (customerIsOperationPossible === null) {
  customerIsOperationPossible = false
} else {
  customerIsOperationPossible = customerIsOperationPossible.toLowerCase() === 'true'
}

let displayFlag = sessionStorage.getItem('customerDisplayFlag')
if (displayFlag === null) {
  displayFlag = false
} else {
  displayFlag = displayFlag.toLowerCase() === 'true'
}
export default new Vuex.Store({
  state: {
    errorMsg: null,
    bothFamilyName1: '',
    bothFamilyName2: '',
    groomLastName: '',
    groomFirstName: '',
    groomLastNameKana: '',
    groomFirstNameKana: '',
    groomPhoneNumber: '',
    brideLastName: '',
    brideFirstName: '',
    brideLastNameKana: '',
    brideFirstNameKana: '',
    bridePhoneNumber: '',
    mailAddress: '',
    brideMailAddress: '',
    shinroShinpu1: '',
    shinroShinpu2: '',
    personalInformationFlag: '',
    imageFlag: '',
    signalingReceiveData: null,
    isOperationPossible: customerIsOperationPossible,
    customerDisplayFlag: displayFlag
  },
  getters: {
    errorMsg: state => state.errorMsg,
    bothFamilyName1: state => state.bothFamilyName1,
    bothFamilyName2: state => state.bothFamilyName2,
    groomLastName: state => state.groomLastName,
    groomFirstName: state => state.groomFirstName,
    groomLastNameKana: state => state.groomLastNameKana,
    groomFirstNameKana: state => state.groomFirstNameKana,
    groomPhoneNumber: state => state.groomPhoneNumber,
    brideLastName: state => state.brideLastName,
    brideFirstName: state => state.brideFirstName,
    brideLastNameKana: state => state.brideLastNameKana,
    brideFirstNameKana: state => state.brideFirstNameKana,
    bridePhoneNumber: state => state.bridePhoneNumber,
    mailAddress: state => state.mailAddress,
    brideMailAddress: state => state.brideMailAddress,
    shinroShinpu1: state => state.shinroShinpu1,
    shinroShinpu2: state => state.shinroShinpu2,
    personalInformationFlag: state => state.personalInformationFlag,
    imageFlag: state => state.imageFlag,
    signalingReceiveData: state => state.signalingReceiveData,
    isOperationPossible: state => state.isOperationPossible,
    customerDisplayFlag: state => state.customerDisplayFlag
  },
  mutations: {
    setErrorMsg (state, str) {
      state.errorMsg = str
    },
    setBothFamilyName1 (state, str) {
      state.bothFamilyName1 = str
    },
    setBothFamilyName2 (state, str) {
      state.bothFamilyName2 = str
    },
    setGroomLastName (state, str) {
      state.groomLastName = str
    },
    setGroomFirstName (state, str) {
      state.groomFirstName = str
    },
    setGroomLastNameKana (state, str) {
      state.groomLastNameKana = str
    },
    setGroomFirstNameKana (state, str) {
      state.groomFirstNameKana = str
    },
    setGroomPhoneNumber (state, str) {
      state.groomPhoneNumber = str
    },
    setBrideLastName (state, str) {
      state.brideLastName = str
    },
    setBrideFirstName (state, str) {
      state.brideFirstName = str
    },
    setBrideLastNameKana (state, str) {
      state.brideLastNameKana = str
    },
    setBrideFirstNameKana (state, str) {
      state.brideFirstNameKana = str
    },
    setBridePhoneNumber (state, str) {
      state.bridePhoneNumber = str
    },
    setMailAddress (state, str) {
      state.mailAddress = str
    },
    setBrideMailAddress (state, str) {
      state.brideMailAddress = str
    },
    setShinroShinpu1 (state, str) {
      state.shinroShinpu1 = str
    },
    setShinroShinpu2 (state, str) {
      state.shinroShinpu2 = str
    },
    setPersonalInformationFlag (state, str) {
      state.personalInformationFlag = str
    },
    setImageFlag (state, str) {
      state.imageFlag = str
    },
    setSignalingReceiveData (state, msg) {
      state.signalingReceiveData = msg
    },
    setIsOperationPossible (state, bool) {
      state.isOperationPossible = bool
      sessionStorage.setItem('customerIsOperationPossible', bool)
    },
    setCustomerDisplayFlag (state, bool) {
      state.customerDisplayFlag = bool
      sessionStorage.setItem('customerDisplayFlag', bool)
    }
  },
  action: {
    setErrorMsg (context, str) {
      context.commit('setErrorMsg', str)
    },
    setBothFamilyName1 (context, str) {
      context.commit('setBothFamilyName1', str)
    },
    setBothFamilyName2 (context, str) {
      context.commit('setBothFamilyName2', str)
    },
    setGroomLastName (context, str) {
      context.commit('setGroomLastName', str)
    },
    setGroomFirstName (context, str) {
      context.commit('setGroomFirstName', str)
    },
    setGroomLastNameKana (context, str) {
      context.commit('setGroomLastNameKana', str)
    },
    setGroomFirstNameKana (context, str) {
      context.commit('setGroomFirstNameKana', str)
    },
    setGroomPhoneNumber (context, str) {
      context.commit('setGroomPhoneNumber', str)
    },
    setBrideLastName (context, str) {
      context.commit('setBrideLastName', str)
    },
    setBrideFirstName (context, str) {
      context.commit('setBrideFirstName', str)
    },
    setBrideLastNameKana (context, str) {
      context.commit('setBrideLastNameKana', str)
    },
    setBrideFirstNameKana (context, str) {
      context.commit('setBrideFirstNameKana', str)
    },
    setBridePhoneNumber (context, str) {
      context.commit('setBridePhoneNumber', str)
    },
    setMailAddress (context, str) {
      context.commit('setMailAddress', str)
    },
    setBrideMailAddress (context, str) {
      context.commit('setBrideMailAddress', str)
    },
    setShinroShinpu1 (context, str) {
      context.commit('setShinroShinpu1', str)
    },
    setShinroShinpu2 (context, str) {
      context.commit('setShinroShinpu2', str)
    },
    setPersonalInformationFlag (context, str) {
      context.commit('setPersonalInformationFlag', str)
    },
    setImageFlag (context, str) {
      context.commit('setImageFlag', str)
    },
    setSignalingReceiveData (context, msg) {
      context.commit('setSignalingReceiveData', msg)
    },
    setIsOperationPossible (context, bool) {
      context.commit('setIsOperationPossible', bool)
    },
    setCustomerDisplayFlag (context, bool) {
      context.commit('setCustomerDisplayFlag', bool)
    }
  }
})
